import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { label, when } from "@/lib/trust";

function OrgCase({ c, slug, refresh }) {
  const [reason, setReason] = useState("");
  const act = async (action) => {
    try { await api.post(`/communities/${slug}/moderation/cases/${c.case_id}/actions`, { action, reason }); toast.success(`Case ${label(action)}`); refresh(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  const open = !["dismissed", "actioned"].includes(c.status);
  return (
    <div className="rounded border border-[#2A3447] p-3 text-sm" data-testid={`org-case-${c.case_id}`}>
      <p className="text-slate-200">{label(c.target_type)} “{c.target_label}” · <span className="font-mono text-xs uppercase text-aether-300">{label(c.status)}</span> · {c.report_count} report(s)</p>
      <ul className="mt-1 list-disc pl-5 text-xs text-slate-400">{c.reports.map((r, i) => <li key={i}>{label(r.category)}: {r.details}</li>)}</ul>
      {open && <div className="mt-2 flex flex-wrap gap-2">
        <input className="field flex-1" placeholder="Reason (min 10 characters)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid={`org-case-reason-${c.case_id}`} />
        {["dismiss", "org_warning", "remove_member", "escalate"].map((a) => <button key={a} className="btn-outline text-xs" onClick={() => act(a)} data-testid={`org-case-${a}-${c.case_id}`}>{label(a)}</button>)}
      </div>}
      <p className="mt-1 text-[11px] text-slate-500">Opened {when(c.created_at)}</p>
    </div>
  );
}

export function OrgModeration({ slug }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["org-cases", slug], queryFn: () => api.get(`/communities/${slug}/moderation/cases`).then((r) => r.data), retry: false });
  if (!data) return null;
  return (
    <section className="panel space-y-3 p-5" data-testid="org-moderation">
      <p className="eyebrow">Community reports</p>
      <p className="text-xs text-slate-500">Reports about this community's content. You can dismiss, warn, remove a member or escalate to platform staff. Reporter identities stay private; platform moderators keep oversight.</p>
      {data.items.map((c) => <OrgCase key={c.case_id} c={c} slug={slug} refresh={() => qc.invalidateQueries({ queryKey: ["org-cases", slug] })} />)}
      {!data.items.length && <p className="text-sm text-slate-500" data-testid="org-moderation-empty">No reports about this community.</p>}
    </section>
  );
}
